import React from "react";

const tone = (v) => (v > 100 ? "bg-red-500" : v >= 90 ? "bg-amber-500" : "bg-brand");

// consum real (bară plină) vs. planificat (marcaj) raportat la buget
export function BudgetBar({ totals, testid, compact = false }) {
  if (!totals || totals.status === "no_budget") {
    return <div className="text-[11px] text-ink-muted" data-testid={testid}>Fără buget definit</div>;
  }
  const actual = totals.actual_pct || 0;
  const planned = totals.planned_pct || 0;
  return (
    <div data-testid={testid}>
      <div className="flex items-center justify-between text-[11px] mb-1">
        <span className="text-ink-muted">Consumat <b className="text-ink tabular-nums">{actual.toFixed(0)}%</b></span>
        <span className={`tabular-nums ${planned > 100 ? "text-red-600 font-semibold" : planned >= 90 ? "text-amber-600" : "text-ink-muted"}`}>
          Planificat {planned.toFixed(0)}%
        </span>
      </div>
      <div className={`relative ${compact ? "h-1.5" : "h-2"} rounded-full bg-slate-100 overflow-hidden`}>
        <div className="absolute inset-y-0 left-0 bg-brand/20 transition-[width] duration-500" style={{ width: `${Math.min(planned, 100)}%` }} />
        <div className={`absolute inset-y-0 left-0 rounded-full transition-[width] duration-500 ${tone(actual)}`} style={{ width: `${Math.min(actual, 100)}%` }} />
      </div>
    </div>
  );
}
